// extracted by mini-css-extract-plugin
module.exports = {"TradeInCompoment":"TradeIn_TradeInCompoment__mJVLb","TradeInOnline":"TradeIn_TradeInOnline__TSf1T"};